/**
 * Paynet super app (`paynet.insonuchun.uz`) host adapter — `definePathParamHost`
 * factory orqali.
 *
 * Paynet mini app'ni imzolangan tokenni URL YO'LIGA joylab ochadi:
 *
 *     https://paynet.insonuchun.uz/paynet/login/<token>
 *
 * Mini app shu tokenni path'dan olib `/MiniApp/PaynetLogin` ga `{ token }` bo'lib
 * jo'natadi va javobdagi JWT'ni sessionStorage'ga saqlaydi. Javob kengaytirilgan
 * `VendorLoginResponse` shaklida (nested `user`) — factory `mapVendorResponse`
 * bilan normalizatsiya qiladi.
 *
 * Javobda `theme` ("dark" | "light") ham keladi; uni `persistPreferredTheme`
 * orqali localStorage'ga yozamiz — `getInitialTheme()` (useTheme) shu kalitni
 * o'qigani uchun mavzu boot'da avtomatik qo'llanadi (theme boot'iga tegilmaydi).
 */

import { persistPreferredTheme } from "@/lib/env";
import { definePathParamHost } from "./pathParamHost";

export const paynetHost = definePathParamHost({
  id: "paynet",
  brandId: "paynet",
  hostnames: ["paynet.insonuchun.uz"],
  loginEndpoint: "/MiniApp/PaynetLogin",
  pathPrefix: "/paynet/login/",
  payloadKey: "token",
  onLoginResponse: (raw) => persistPreferredTheme(raw.theme),
});
